import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import './reactionGridModal.scss';
import { getLocalUserDetails } from '../../../../utils';

export const ReactionGridModal = ({ id, reactions, allReactions, onSelectReaction }) => {
   const localUserId = getLocalUserDetails()?.userId;
   const { cumulativeCount, emojiData } = useMemo(() => {
      if (reactions) {
         const entries = Object.entries(reactions);
         const count = entries.reduce((acc, [, data]) => acc + data.count, 0);
         const mapped = entries.map(([emoji, data]) => ({
            emoji,
            count: data.count,
            reactedByMe: data.users?.includes(localUserId) || false,
         }));
         return { cumulativeCount: count, emojiData: mapped };
      } else if (allReactions) {
         return {
            cumulativeCount: 0,
            emojiData: allReactions.map(emoji => ({
               emoji,
               count: 0,
               reactedByMe: false,
            })),
         };
      }
      return { cumulativeCount: 0, emojiData: [] };
   }, [reactions, allReactions, localUserId]);

   let title = 'Reactions';

   if (cumulativeCount === 1) {
      title = 'Reaction';
   }
   if (cumulativeCount > 1) {
      title = `${cumulativeCount} Reactions`;
   }

   return (
      <div className="reaction-grid-modal" id={id}>
         <div className="header">
            <span>{title}</span>
         </div>
         <div className="grid">
            {emojiData.map(({ emoji, count, reactedByMe }) => (
               <button
                  key={emoji}
                  className={`emoji-button ${reactedByMe ? 'active' : ''}`}
                  onClick={() => onSelectReaction(emoji)}>
                  <span className="emoji">{emoji}</span>
                  {count > 0 && <span className="count">{count}</span>}
               </button>
            ))}
         </div>
      </div>
   );
};

ReactionGridModal.propTypes = {
   id: PropTypes.string,
   reactions: PropTypes.object, // { emoji: { count: number, users: [] } }
   allReactions: PropTypes.arrayOf(PropTypes.string),
   onSelectReaction: PropTypes.func.isRequired,
};
